import LazyLoader from "@loadable/component";
import React from "react";
import Loader from "../components/Loader";

/**
 * Creates a lazy-loaded component with consistent fallback
 * Reduces boilerplate in route definitions
 *
 * @param {Function} importFn - Dynamic import function
 * @param {Object} options - Additional options for loadable
 * @param {React.ReactNode} options.fallback - Custom fallback component (default: Loader)
 * @returns {React.ComponentType} Lazy-loaded component
 *
 * @example
 * // Before:
 * const Home = LazyLoader(() => import("../../pages/modules/Home/Home"), { fallback: <Loader /> });
 *
 * // After:
 * const Home = lazyLoad(() => import("../../pages/modules/Home/Home"));
 */
const lazyLoad = (importFn, options = {}) => {
  return LazyLoader(importFn, {
    fallback: <Loader />,
    ...options,
  });
};

export default lazyLoad;
